import {EventEmitter, Injectable, Output} from '@angular/core';
import {ConfService} from '../conf.service';
import {environment} from '../../environments/environment';
import {ConnecttocrudService} from '../connecttocrud.service';
import {AlertService} from '../alert.service';
import {AuthedApiService} from '../authed-api.service';

@Injectable({
  providedIn: 'root'
})
export class BusinessLogicDataService {

  partner = localStorage.getItem('partner');
  account = localStorage.getItem('account');
  signInEmail = localStorage.getItem('signInEmail');

  isDocumentationDataFetchLoading = false;
  isDocumentationFetchError = false;
  blockDescriptionCategories: any;
  blocklyDocumentationInitialKey: string;

  isMyAPIsFetchLoading = false;
  isMyAPIsFetchError = false;
  myAPIsBlocksData: any;
  myAPIsForceFetchNextCall = false;

  isSubscriptionsFetchLoading = false;
  isSubscriptionsFetchError = false;
  myServiceProviderAPIs: any;
  b2bServiceProviderAPIs: any;
  subscriptionsForceFetchNextCall = false;

  isAuthorizationTypesFetchLoading = false;
  isAuthorizationTypesFetchError = false;
  authorizationTypesData: any;

  isAlertsAttributesFetchLoading = false;
  isAlertsAttributesFetchError = false;
  alertsForceFetchNextCall = false;
  alertsTopicAttributeData: any;
  alertRefreshSubscription: any;

  isTriggersAttributesFetchLoading = false;
  isTriggersAttributesFetchError = false;
  triggersForceFetchNextCall = false;
  triggersTopicAttributeData: any;

  isProviderConnectorsFetchLoading = false;
  isProviderConnectorsFetchError = false;
  providerConnectorsFetchNextCall = false;
  providerConnectorsData: any;

  isAcceleratorsFetchLoading = false;
  isAcceleratorsFetchError = false;
  acceleratorsForceFetchNextCall = false;
  acceleratorsData: any;

  isDevToolsBlocksFetchLoading = false;
  isDevToolsBlocksFetchError = false;
  devToolsBlocksForceFetchNextCall = false;
  devToolsBlocksData: any;

  isJSsciptsLoading = false;
  isJSScriptsFetchError = false;
  jsScriptLibs: any;

  constructor(private confPost: ConfService,
              public alertService: AlertService,
              private apiService: AuthedApiService,
              private _service: ConnecttocrudService) {
    this.refreshEventSetup();
  }


  refreshEventSetup() {
    if (this.alertRefreshSubscription === undefined) { //
      this.alertRefreshSubscription = this.alertService.alertRefreshListener.subscribe(
          (eventObject) => {
            if (eventObject && eventObject.action === 'init' || eventObject.action === 'subscription') {
              this.alertsForceFetchNextCall = true;
            }
          }
      );
    }
  }

  private setDocumentationData(forceDataFetch) {
    return new Promise((resolve, reject) => {
      if (this.blockDescriptionCategories !== null && this.blockDescriptionCategories !== undefined && !forceDataFetch) {
        resolve('success');
      } else {
        this.isDocumentationDataFetchLoading = true;
        this.blockDescriptionCategories = {};
        this.blocklyDocumentationInitialKey = null;
        this.confPost.getData('services', 'services', 'v1', 'blocklyDocumentation', null)
            .toPromise().then(data => {
          let blocklyDocumentation: any;
          blocklyDocumentation = data;

          if (blocklyDocumentation) {
            for (const [i, blocklyDoc] of blocklyDocumentation.entries()) {
              if (blocklyDoc && blocklyDoc.category && blocklyDoc.block_descriptions && blocklyDoc.block_descriptions.length > 0) {
                this.blockDescriptionCategories[blocklyDoc.category] = blocklyDoc.block_descriptions;
              }
              if (i === 0) {
                this.blocklyDocumentationInitialKey = blocklyDoc.category;
              }
            }
          }
          this.isDocumentationDataFetchLoading = false;
          this.isDocumentationFetchError = false;
          resolve('success');
        }, error => {
          this.isDocumentationDataFetchLoading = false;
          this.isDocumentationFetchError = true;
          reject(error);
        });
      }
    });
  }

  // Fetches the data if data is already not there or if forceDataFetch is set to true. Returns Documentation of first index.
  setAndGetDocumentationInitialData(forceDataFetch = false) {
    return new Promise((resolve, reject) => {
      Promise.resolve(this.setDocumentationData(forceDataFetch)).then(resp1 => {

        if (this.blockDescriptionCategories) {
          if (this.blocklyDocumentationInitialKey) {
            // console.log(this.blockDescriptionCategories[this.blocklyDocumentationInitialKey]);
            resolve({initialDocumentation: this.blockDescriptionCategories[this.blocklyDocumentationInitialKey]});
          } else {
            resolve({initialDocumentation: []});
          }
        }
      });
    });
  }

  // Fetches the blocks data for My APIs. Set forceDataFetch as true to force the API call.
  setMyAPIsBlocksData(forceDataFetch) {
    this.setPartnerAccount();
    return new Promise((resolve, reject) => {
      if (this.myAPIsBlocksData !== null && this.myAPIsBlocksData !== undefined && !forceDataFetch && !this.myAPIsForceFetchNextCall) {
        resolve('success');
      } else {
        this.isMyAPIsFetchLoading = true;
        this.confPost.postCoreApi(environment.coreAPI.applicationLogicBlocks.name, environment.coreAPI.applicationLogicBlocks.version,
            {partner: this.partner, account: this.account}).subscribe(data => {
          let res: any;
          res = data;
          this.myAPIsBlocksData = res['items'];
          this.isMyAPIsFetchLoading = false;
          this.myAPIsForceFetchNextCall = false;
          this.isMyAPIsFetchError = false;
          resolve('success');
        }, error => {
          this.myAPIsForceFetchNextCall = false;
          this.isMyAPIsFetchLoading = false;
          this.isMyAPIsFetchError = true;
          resolve('failed');
        });
      }
    });
  }

  // Fetches the blocks data for Service provider subscriptions. Set forceDataFetch as true to force the API call.
  setSubscriptionsBlocksData(forceDataFetch) {
    this.setPartnerAccount();
    return new Promise((resolve, reject) => {
      if (this.myServiceProviderAPIs !== null && this.myServiceProviderAPIs !== undefined
          && this.b2bServiceProviderAPIs !== null && this.b2bServiceProviderAPIs !== undefined
          && !forceDataFetch && !this.subscriptionsForceFetchNextCall) {
        resolve('success');
      } else {
        this.isSubscriptionsFetchLoading = true;
        this.confPost.postCoreApi(environment.coreAPI.applicationLogicSubscriptionBlocks.name,
            environment.coreAPI.applicationLogicSubscriptionBlocks.version,
            {partner: this.partner, account: this.account}).subscribe(data => {
          let res: any;
          res = data;
          this.myServiceProviderAPIs = res['myProviders'];
          this.b2bServiceProviderAPIs = res['b2bProviders'];
          this.isSubscriptionsFetchLoading = false;
          this.isSubscriptionsFetchError = false;
          this.subscriptionsForceFetchNextCall = false;
          resolve('success');
        }, error => {
          this.isSubscriptionsFetchLoading = false;
          this.isSubscriptionsFetchError = true;
          this.subscriptionsForceFetchNextCall = false;
          resolve('failed');
        });
      }
    });
  }

  // Fetches the Authorization Types data. Set forceDataFetch as true to force the API call.
  setAuthorizationTypesData(forceDataFetch = false) {
    this.setPartnerAccount();
    return new Promise((resolve, reject) => {
      if (this.authorizationTypesData !== null && this.authorizationTypesData !== undefined && !forceDataFetch) {
        resolve('success');
      } else {
        this.isAuthorizationTypesFetchLoading = true;
        this._service.getItems('v1', 'services', 'services', 'authorizationTypes', false).subscribe(authTypes => {
          let res: any;
          res = authTypes;
          this.authorizationTypesData = res;
          this.isAuthorizationTypesFetchLoading = false;
          this.isAuthorizationTypesFetchError = false;
          resolve('success');
        }, error => {
          this.isAuthorizationTypesFetchLoading = false;
          this.isAuthorizationTypesFetchError = true;
          resolve('failed');
        });
      }
    });
  }

  // Fetches the Dev tools data. Set forceDataFetch as true to force the API call.
  setDevToolsBlocksData(forceDataFetch = false) {
    this.setPartnerAccount();
    return new Promise((resolve, reject) => {
      if (this.devToolsBlocksData !== null && this.devToolsBlocksData !== undefined && !forceDataFetch && !this.devToolsBlocksForceFetchNextCall) {
        resolve('success');
      } else {
        this.isDevToolsBlocksFetchLoading = true;
        this.confPost.getCoreApi(environment.coreAPI.devToolsBlocks.name, environment.coreAPI.devToolsBlocks.version,
            'partner=' + this.partner + '&account=' + this.account).subscribe(data => {
          let res: any;
          res = data;
          this.devToolsBlocksData = res;
          this.isDevToolsBlocksFetchLoading = false;
          this.isDevToolsBlocksFetchError = false;
          resolve('success');
        }, error => {
          this.isDevToolsBlocksFetchLoading = false;
          this.isDevToolsBlocksFetchError = true;
          resolve('failed');
        });
      }
    });
  }

  // Fetches the blocks data for Alerts. Set forceDataFetch as true to force the API call.
  setAlertsBlocksData(forceDataFetch = false) {
    this.setPartnerAccount();
    return new Promise((resolve, reject) => {
      if (this.alertsTopicAttributeData !== null && this.alertsTopicAttributeData !== undefined &&
          !this.alertsForceFetchNextCall && !forceDataFetch) {
        resolve('success');
      } else {
        this.isAlertsAttributesFetchLoading = true;
        const payload = {
          'intent': 'businesslogic-alerts',
          'user': this.signInEmail,
          'partner': this.partner,
          'account': this.account
        };
        this.confPost.postCoreApi(environment.coreAPI.alerts.name, environment.coreAPI.alerts.version, payload).subscribe(data => {
          let res: any;
          res = data;

          const topics = res['items'];
          if (topics.length > 0) {
            this.alertsTopicAttributeData = res['items'];
          } else {
            this.alertsTopicAttributeData = [['Select an alert', 'null']];
          }

          this.alertsForceFetchNextCall = false;
          this.isAlertsAttributesFetchLoading = false;
          this.isAlertsAttributesFetchError = false;
          resolve('success');
        }, error => {
          this.alertsTopicAttributeData = [['Select an alert', 'null']];
          this.isAlertsAttributesFetchLoading = false;
          this.isAlertsAttributesFetchError = true;
          resolve('failed');
        });
      }
    });
  }

  // Fetches the blocks data for Triggers. Set forceDataFetch as true to force the API call.
  setTriggersBlocksData(forceDataFetch = false) {
    this.setPartnerAccount();
    return new Promise((resolve, reject) => {
      if (this.triggersTopicAttributeData !== null && this.triggersTopicAttributeData !== undefined &&
          !this.triggersForceFetchNextCall && !forceDataFetch) {
        resolve('success');
      } else {
        this.isTriggersAttributesFetchLoading = true;
        const payload = {
          'intent': 'businesslogic-triggers',
          'partner': this.partner,
          'account': this.account
        };
        this.confPost.postCoreApi(environment.coreAPI.triggers.name, environment.coreAPI.triggers.version, payload).subscribe(data => {
          let res: any;
          res = data;

          const topics = res['items'];
          if (topics.length > 0) {
            this.triggersTopicAttributeData = res['items'];
          } else {
            this.triggersTopicAttributeData = [['Select a trigger', 'null']];
          }

          this.triggersForceFetchNextCall = false;
          this.isTriggersAttributesFetchLoading = false;
          this.isTriggersAttributesFetchError = false;
          resolve('success');
        }, error => {
          this.triggersTopicAttributeData = [['Select a trigger', 'null']];
          this.isTriggersAttributesFetchLoading = false;
          this.isTriggersAttributesFetchError = true;
          resolve('failed');
        });
      }
    });
  }

  // Fetches the blocks data for Service provider connectors. Set forceDataFetch as true to force the API call.
  setProvidersConnectosData(forceDataFetch = false) {
    this.setPartnerAccount();
    return new Promise((resolve, reject) => {
      if (this.providerConnectorsData !== null && this.providerConnectorsData !== undefined &&
          !this.providerConnectorsFetchNextCall && !forceDataFetch) {
        resolve('success');
      } else {
        this.isProviderConnectorsFetchLoading = true;
        this.providerConnectorsData = [];
        this.confPost.getData('services', 'services', 'v1', 'apiconnectors',
            'partner=' + this.partner + '&account=' + this.account).subscribe(data => {
          let res: any;
          res = data;
          res.forEach(registeredConnector => {
            if (registeredConnector['connectors']) {
              const connectorList = registeredConnector['connectors'];
              if (connectorList) {
                connectorList.forEach(connector => {
                  this.providerConnectorsData.push([registeredConnector.producer + '_' +
                  connector.authType + '_' + connector.name, registeredConnector.producer + '_' +
                  connector.authType + '_' + connector.name]);
                });
              }
            }
          });
          if (this.providerConnectorsData.length === 0) {
            this.providerConnectorsData = [['Select a connector', 'null']];
          }

          this.providerConnectorsFetchNextCall = false;
          this.isProviderConnectorsFetchLoading = false;
          this.isProviderConnectorsFetchError = false;
          resolve('success');
        }, error => {
          this.providerConnectorsData = [['Select a connector', 'null']];
          this.isProviderConnectorsFetchLoading = false;
          this.isProviderConnectorsFetchError = true;
          resolve('failed');
        });
      }
    });
  }

  // Unfinished
  // Fetches the blocks data for My APIs. Set forceDataFetch as true to force the API call.
  setAcceleratorsData(forceDataFetch = false) {
    this.setPartnerAccount();
    return new Promise((resolve, reject) => {
      if (this.acceleratorsData !== null && this.acceleratorsData !== undefined &&
          !this.acceleratorsForceFetchNextCall && !forceDataFetch) {
        resolve('success');
      } else {
        this.isAcceleratorsFetchLoading = true;
        const payload = {
          significance: 'compose',
          intent: 'subscriptions',
          partner: this.partner,
          account: this.account
        };
        this.apiService.getAccelerators(payload).subscribe(data => {
          let res: any;
          res = data;
          this.acceleratorsData = res;
          this.acceleratorsForceFetchNextCall = false;
          this.isAcceleratorsFetchLoading = false;
          this.isAcceleratorsFetchError = false;
          resolve('success');
        }, error => {
          this.isAcceleratorsFetchLoading = false;
          this.isAcceleratorsFetchError = true;
          resolve('failed');
        });
      }
    });
  }

  // Fetches the JS scripts data. Set forceDataFetch as true to force the API call.
  setJSScriptsData(forceDataFetch = false) {
    this.setPartnerAccount();
    return new Promise((resolve, reject) => {
      if (this.jsScriptLibs !== null && this.jsScriptLibs !== undefined && !forceDataFetch) {
        resolve('success');
      } else {
        this.isJSsciptsLoading = true;
        this.apiService.getCoreApi(environment.coreAPI.jsScripts.name, environment.coreAPI.jsScripts.version).subscribe(authTypes => {
          let res: any;
          res = authTypes;
          this.jsScriptLibs = res;
          this.isJSsciptsLoading = false;
          this.isJSScriptsFetchError = false;
          resolve('success');
        }, error => {
          this.isJSsciptsLoading = false;
          this.isJSScriptsFetchError = true;
          resolve('failed');
        });
      }
    });
  }

  setPartnerAccount() {
    this.partner = localStorage.getItem('partner');
    this.account = localStorage.getItem('account');
    this.signInEmail = localStorage.getItem('signInEmail');
  }
}
